import { fromJS, Map } from 'immutable'
import * as ROLES from './roles'

export const MICROACTIONS_PATH = '/microactions'
export const LAUNCH_PATH = 'launch'
export const REVIEWS_PATH = '/reviews'
export const REVIEWS_SURVEYS = `/surveys`
export const REVIEWS_SURVEYS_PATH = `${REVIEWS_PATH}${REVIEWS_SURVEYS}`
export const REVIEWS_SURVEYS_CREATE_PATH = `${REVIEWS_SURVEYS}/create`
const REVIEWS_SURVEY_COMPLETED = `/completed`
export const REVIEWS_SURVEY_PATH = `/reviews-survey-quiz`
export const REVIEWS_SURVEY_COMPLETED_PATH = `${REVIEWS_SURVEY_PATH}${REVIEWS_SURVEY_COMPLETED}`

export const subNavLinks = [
  {
    name: 'MicroActions',
    path: MICROACTIONS_PATH,
  },
  {
    name: 'Reviews',
    path: REVIEWS_PATH,
  },
]

export const navReviewsLinks = [
  {
    name: 'Review Surveys',
    path: `${REVIEWS_PATH}${REVIEWS_SURVEYS}`,
  },
]

const linksSuperAndMultiAdmins = {
  '/organizations': {
    name: 'Organizations',
    path: `${MICROACTIONS_PATH}/organizations`,
  },
  '/users': {
    name: 'Users',
    path: `${MICROACTIONS_PATH}/users`,
  },
  '/protracks': {
    name: 'ProTracks',
    path: `${MICROACTIONS_PATH}/protracks`,
  },
}

export default fromJS({
  [ROLES.USER]: {},
  [ROLES.ADMIN]: {
    '/users': {
      name: 'Users',
      path: `${MICROACTIONS_PATH}/users`,
    },
  },
  [ROLES.SUPER_ADMIN]: linksSuperAndMultiAdmins,
  [ROLES.MULTI_ADMIN]: linksSuperAndMultiAdmins,
}) as Map<string, any>

export const createLinks = (match: { url: string }, isSuperAdmin: boolean) => {
  const commonLinks = [
    {
      path: `${match.url}/holidays`,
      name: 'Holidays',
    },
    {
      path: `${match.url}/promo-page`,
      name: 'Promo Page',
    },
  ]
  const linksOnlyForSuperAdmin = [
    {
      path: `${match.url}/values`,
      name: 'Organization Values',
    },
    // TODO: Now inactive notifications works wrong (with bugs)
    // TODO: so it must be discussed before usage, or removed at all
    // {
    //   path: `${MICROACTIONS_PATH}/organizations/${orgId}/settings/inactive-notifications`,
    //   name: 'Inactive Notifications',
    // },
    {
      path: `${match.url}/one-signal`,
      name: 'OneSignal App',
    },
    {
      path: `${match.url}/children`,
      name: 'Child Organizations',
    },
    {
      path: `${match.url}/partners-links`,
      name: 'Partner Promo Link',
    },
  ]
  if (isSuperAdmin) {
    return [...commonLinks, ...linksOnlyForSuperAdmin]
  }
  return [...commonLinks]
}
